"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.symbol = symbol;
function symbol() {
    // eslint-disable-next-line max-len,quotes
    return '<symbol viewbox="0 0 24 24" id=icon-play-24><path d="m6.754 2.256 14.4 8.331c1.128.653 1.128 2.173 0 2.826l-14.4 8.331C5.555 22.438 4 21.64 4 20.331V3.67c0-1.31 1.555-2.108 2.754-1.414Z"></path></symbol>';
}
